export const TestHooks = {
	ClientIntakeURL: 'client-intake-url',
} as const;
